import config from "../config";
import { sendPostRequest } from "../Utility/FetchUtils";

class LoadPortApi {
  static BASE_URL = config.SERVICE_URL + "/loadport";

  static storeContents(moduleIdentifier: string) {
    var endpoint = this.BASE_URL + "/:store-content/" + moduleIdentifier;
    return sendPostRequest(endpoint);
  }

  static storeActiveContents(moduleIdentifier: string) {
    var endpoint = this.BASE_URL + "/:store-active-content/" + moduleIdentifier;
    return sendPostRequest(endpoint);
  }

  static Scan(moduleIdentifier: string) {
    let endpoint = this.BASE_URL + "/" + moduleIdentifier + ":scan";
    return sendPostRequest(endpoint);
  }

  static ejectLoadPort(moduleIdentifier: string) {
    let endpoint = this.BASE_URL + "/eject/" + moduleIdentifier;
    return sendPostRequest(endpoint);
  }

  static retractLoadPort(moduleIdentifier: string) {
    let endpoint = this.BASE_URL + "/retract/" + moduleIdentifier;
    return sendPostRequest(endpoint);
  }
}

export default LoadPortApi;
